import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { Lock } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr] bg-white">
      <div className="hidden lg:flex flex-col justify-between bg-[#0b1f3a] text-white p-14">
        <div className="eyebrow !text-slate-400">Genève · Family Office</div>
        <div className="fade-up">
          <div className="font-display text-6xl leading-[1.05]">Campus Holding <span className="italic">AI</span></div>
          <p className="mt-6 text-slate-300 max-w-md text-[15px] leading-relaxed">
            Plateforme privée de prospection B2B : import, qualification des décideurs, campagnes Microsoft 365 et suivi des réponses — sous votre contrôle.
          </p>
        </div>
        <div className="text-xs text-slate-500">Accès réservé · Toute opération est journalisée</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 fade-up" data-testid="login-form">
          <div>
            <Lock className="h-5 w-5 text-[#0b1f3a] mb-4" />
            <h1 className="font-display text-3xl text-[#0b1f3a]">Connexion</h1>
            <p className="text-sm text-slate-500 mt-1">Accès administrateur</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
          </div>
          {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2" data-testid="login-error">{error}</div>}
          <Button type="submit" className="w-full h-11" disabled={loading} data-testid="login-submit-button">{loading ? "Connexion…" : "Se connecter"}</Button>
        </form>
      </div>
    </div>
  );
}
